import React from 'react';

function Footer(props) {
  return (
    <footer>
      <div className='footer'>
        <p className='footer__text'>
          © 2021 Daniel Adebonojo, devchallenges.io
        </p>
      </div>
    </footer>
  );
}

export default Footer;
